export function replaceHighlight(str, style = 'color-yellow-5'): string {
  return str.replace(
    /<highlight>(.*?)<\/highlight>/g,
    `<span class='${style}'>$1</span>`,
  );
}
